import { THIS_EXPR } from "@angular/compiler/src/output/output_ast";

export class Empresa {

  IdEmpresa: number;
  Ruc: number;
  RazonSocial: string;
  NombreComercial: string;
  Atencion: string;
  Telefono1: string;
  Telefono2: string;
  I038_DiasCredito: string;
  IdZona: string;
  IdUbigeo: string;
  Direccion: string;
  DireccionNumero: string;
  Referencia: string;
  Latitud: string;
  Longitud: string;
  DireccionFactura: string;
  Email: string;
  Prefijo: string;
  RequeridoCentroCosto: string;
  MovilFechaFabricacion: number;
  MovilAireAcondicionado: number;
  MovilMaleteraAmplia: number;
  ValeElectronico: Boolean;
  ValeFisico: boolean;
  PagoCredito: boolean;
  Activo: boolean;
  Prioridad: number;
  Fonema: string;
  Campos: string;
  Creacion_Usuario: string;
  Creacion_Fecha: any;
  Modifico_Usuario: string;
  Modifico_Fecha: any;
  CodGrupo: boolean;
  TiempoReserva: string;
  TiempoEspera: string;
  ConDeuda: string;
  Configuracion: string;
  Informativo: string;
  IdDistritoFactura: string;
  PrepagoRecibido: string;
  PrepagoUsado: string;
  PrepagoDisponible: string;
  Presupuesto: string;
  FlagPresupuesto: string;
  BloqueoEmpresa: number;
  HoraInicioServicio: string;
  HoraFinServicio: string;
  RequiereAprovacion: string;
  NRHoras: string;
  Dias: string;
  EstadoPresupuesto: string;
  EditCC: number;
  FechaCorte: string;
  Observacion: string;;
  saldo: string;
  hotel: string;
  notaObligatoria: string;

  isoCountryCode: string;
  ciudad: string;
  provincia: string;
  codigoPostal: number;
  pais: string;
  ckEditCC: boolean;
  notificarSupervisores: boolean;

  IsoCountryCheck: boolean;
  recargoTarifa: number;
  
  //deshabilitarVisibilidadTarifa
  deshabilitarVisibilidadTarifa: boolean;
  correoFinalizacionServicio : boolean
  //Tipo de informacion codigo/descripcioon de cc en 
  habilitarVisibilidadDescripcion: boolean;

  // descuento for IvanCar
  diasDescuento : string;
  montoDescuento : number;
  HabilitarSede:boolean

  constructor() {
    this.Activo = true;
    this.Atencion = "";
    this.BloqueoEmpresa = 0;
    this.Campos = '<r />';
    this.CodGrupo = null;
    this.ConDeuda = "";
    this.Configuracion = ""
    this.Creacion_Fecha = "";
    this.Creacion_Usuario = "";
    this.Dias = "";
    this.Direccion = "";
    this.DireccionFactura = ""
    this.DireccionNumero = ""
    this.EditCC = 1;
    this.EstadoPresupuesto = "";
    this.FechaCorte = "";
    this.FlagPresupuesto = null;
    this.Fonema = "";
    this.HoraFinServicio = "";
    this.HoraInicioServicio = "";
    this.I038_DiasCredito = "";
    this.IdDistritoFactura = "";
    //this.IdEmpresa=null;
    this.IdUbigeo = "";
    this.IdZona = "";
    this.Informativo = "";
    this.Latitud = "";
    this.Longitud = "";
    this.Modifico_Fecha = "";
    this.Modifico_Usuario = "";
    this.MovilAireAcondicionado = 0;
    this.MovilFechaFabricacion = 0;
    this.MovilMaleteraAmplia = 0;
    this.NRHoras = "";
    this.NombreComercial = "";
    this.Observacion = null;
    this.PagoCredito = false
    this.Prefijo = "";
    this.PrepagoDisponible = null;
    this.PrepagoRecibido = null;
    this.PrepagoUsado = null;
    this.Presupuesto = "";
    this.Prioridad = 20180719;
    this.RazonSocial = "";
    this.Referencia = "";
    this.RequeridoCentroCosto = "";
    this.RequiereAprovacion = null;
    this.Telefono1 = "";
    this.Telefono2 = "";
    this.TiempoEspera = "";
    this.TiempoReserva = "";
    this.ValeElectronico = false;
    this.ValeFisico = false;
    this.hotel = "";
    this.notaObligatoria = ""
    this.saldo = "";
    this.isoCountryCode = "";
    this.pais = "PE";
    this.ckEditCC= true;
    this.notificarSupervisores = false;
    
    this.IsoCountryCheck = false;
    this.recargoTarifa = 0;
    this.deshabilitarVisibilidadTarifa = false;
  
    this.habilitarVisibilidadDescripcion = false;
  }

}
